<template>
  <div>
    <div :class="headerIconClass">
      <a @click="handleOpen" style="cursor: pointer;">
        <img v-bind:src="staffInfo.PictureUrl" ref="headerIconImg" style="margin: 0;" />
      </a>
    </div>
  </div>
</template>


<script>
import { SocialPairedBasisInfoHandler } from "../../handler/SocialPairedBasisInfoHandler.js";
import store_dialog from "../../vuex/store_dialog.js";
import { HeaderIconHandler } from "@/handler/HeaderIconHandler.js";
export default {
  name: "MainToolBarStaff",
  data() {
    return {
      staffInfo: { CName: "", FirstName: "", LastName: "", PictureUrl: "" },
      headerIconSizeObject:{height:"",width:""}
    };
  },
  created() {
    var staff = this.GetLoginStaff();
    this.staffInfo = SocialPairedBasisInfoHandler.GetStaffInfo(staff.staffid);
    HeaderIconHandler.getImgSize(this.staffInfo.PictureUrl).then(res=>{ 
      this.headerIconSizeObject = res;
      if(this.headerIconSizeObject.height > this.headerIconSizeObject.width){
        this.$refs.headerIconImg.style.margin = HeaderIconHandler.ComputeMarginVertical(this.headerIconSizeObject.width,this.headerIconSizeObject.height,60);
      }
      if(this.headerIconSizeObject.height < this.headerIconSizeObject.width){
        this.$refs.headerIconImg.style.margin = HeaderIconHandler.ComputeMarginHorizontal(this.headerIconSizeObject.width,this.headerIconSizeObject.height,60);
      }
    });
  },
  methods: {
    handleOpen: function() {
      store_dialog.dispatch("showDialogEditSaleBusinessCard", "1");
    },
  },
  computed:{
    headerIconClass(){
      return {
        circularsquare: this.headerIconSizeObject.height == this.headerIconSizeObject.width,
        circularportraitvertical: this.headerIconSizeObject.height > this.headerIconSizeObject.width,
        circularportraithorizontal: this.headerIconSizeObject.height < this.headerIconSizeObject.width
      };
    }
  }
};
</script> 



<style>
  .circularportraitvertical{
    position:relative;
    width:60px !important;
    height:60px !important;
    overflow:hidden;
    border-radius:50%;
    margin: 15%;
  }
  .circularportraitvertical img{
    width:100%;
    height:auto;
    margin-top: -15px;
  }

  .circularportraithorizontal{
    display:inline-block;
    position:relative;
    width:60px !important;
    height:60px !important;
    overflow:hidden;
    border-radius:50%;
    margin: 15%;
  }
  .circularportraithorizontal img{
    width: auto;
    height: 100%;
    margin-left: -15px;
  }

  .circularsquare{
    margin: 15%;
  }
  .circularsquare img{
    border-radius:50%;
    width:60px !important;
    height:60px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Main/MainToolBbarStaff.vue